<template>
  <div class="bg-white p-4" id="quoteGen">
    <div class="flex items-center py-4 px-0 font-semibold">
      <!-- <img src="@/assets/images/icons/back-icon.svg" @click="$router.go(-1)" class="mr-4 cursor-pointer" />Transaction -->
      <img src="@/assets/images/icons/back-icon.svg" @click="navigateToReg" class="mr-4 cursor-pointer" />Transaction
      View
    </div>
    <div class="flex justify-end items-center invoice-wrap mt-2 mb-6">
      <span v-if="type == 'quote'" @click="setBookingFlowState(transaction)" class="icon"><img alt="" class="mr-1" src="@/assets/images/icons/edit_quote.svg" /></span>
      <span v-if="type == 'quote'" @click=" deleteQuote(transaction)" class="icon cursor-pointer"><img alt="" class="mr-1" src="@/components/Ondemand/Locations/icons/delete.svg" /></span>
      <button @click="generateQuote()" class="px-4 py-4">Send Invoice</button>
    </div>


    <div class="flex justify-end">
      <div>

        <button v-if="type == 'recievable'" class="py-2 px-3 bg-primary-navy text-white my-3 rounded-md hidden">
          <el-dropdown class="h-full">
            <button :disabled="false" :class="{ disabledDrop: true }"
              class="payment-assign h-full font-semibold rounded flex items-center p-2">
              <span class="border-r border-white text-white mr-3 pr-2">Collect Payment</span>

              <arrow-down-filled />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button >Charge Card</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button>Charge Wallet</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button>Bank Transfer</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button>POS</button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </button>
      </div>
    </div>

    <div class="title-container">
      <span class="w-6/12 sm:w-4/12 md:w-3/12 block py-2">Shipping ID #:
        {{
          transaction.shipping ? transaction.shipping.shippingReference : "N/A"
        }}</span>
      <span class="w-6/12 sm:w-4/12 md:w-3/12 block py-2 break-words">Shipping Status:
        {{
          transaction.shipping ? transaction.shipping.deliveryStatus : "N/A"
        }}</span>
      <span class="w-6/12 sm:w-4/12 md:w-3/12 block py-2">Transaction Date:
        {{ (transaction.createdAt || "").split("T")[0] || "N/A" }}</span>
      <span class="w-6/12 sm:w-4/12 md:w-3/12 block py-2">Payment Status: {{ transaction ? transaction.status : "null"
        }}</span>
    </div>

    <div class="flex items-center justify-between py-4 text-right px-2">
      <div>
        <img src="@/assets/images/billing/truck-billing.svg" />
      </div>
      <div>
        <b>
          <abbr v-if="!hasTrip(transaction)">{{
            transaction.shipping && transaction.shipping.shippingservice
              ? transaction.shipping.shippingservice.orgName
              : "N/A"
          }}
          </abbr>
          <abbr v-else>
            {{
              transaction.shipping && transaction.shipping.trip && transaction.shipping.trip.driver
                ? `${transaction.shipping.trip.driver.first_name} ${transaction.shipping.trip.driver.last_name}`
                : "N/A"
            }}
          </abbr>
        </b>
        <ul class="text-right ship-content">
          <!-- <li v-if="!hasTrip(transaction)">
            {{
              transaction.shipping
                ? "N/A" : transaction.shipping.consigneelocation.address.name

            }}
          </li> -->
          <!-- <li>
            <abbr v-if="!hasTrip(transaction)">{{
              transaction.shipping
                ? transaction.shipping.consigneelocation.mobile
                : "N/A"
            }}</abbr>
            <abbr v-else>{{
              transaction.shipping && transaction.shipping.trip && transaction.shipping.trip.driver
                ? transaction.shipping.trip.driver.mobile_no
                : "N/A"
            }}</abbr>
          </li> -->
          <!-- <li>
            <abbr v-if="!hasTrip(transaction)">
              {{
                transaction.shipping
                  ? transaction.shipping.consigneelocation.email
                  : "N/A"
              }}
            </abbr>
            <abbr v-else>
              {{
                transaction.shipping && transaction.shipping.trip && transaction.shipping.trip.driver
                  ? transaction.shipping.trip.driver.email
                  : "N/A"
              }}
            </abbr>
          </li> -->
        </ul>
      </div>
    </div>

    <div class="title-container flex items-center w-full">
      <span>Description:</span>
      <span class="font-semibold pl-2 w-full whitespace-no-wrap truncate">
        {{ discription }}
      </span>
    </div>

    <div class="flex justify-between flex-wrap">
      <div class="flex w-full lg:w-4/12 md:w-6/12 py-3 justify-between flex-wrap border-4 border-white">
        <div v-for="detail in [1]" :key="detail" class="detail-container py-3 px-3">
          <b class="py-2 inline-block">Shipment Info</b>
          <ul class="detail-list">
            <li class="flex items-center justify-between">
              <span>No of Items</span>
              <span>{{
                transaction.shipping ? transaction.shipping.packagees.length : 0
              }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Transaction Channel</span>
              <span>{{
                transaction.shipping
                  && transaction.shipping.trip
                  ? transaction.shipping.trip.bookingChannel
                  : "N/A"
              }}</span>
              <!-- <span>{{ transaction.payment_type || "N/A" }}</span> -->
            </li>
            <li class="flex items-center justify-between">
              <span>Mode of Shipment</span>
              <span>{{
                transaction.shipping.shippingservice
                  ? transaction.shipping.shippingMethod
                  : "N/A"
              }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Service</span>
              <span>{{
                transaction.shipping && transaction.shipping.shippingservice
                  ? transaction.shipping.shippingservice.orgName
                  : "N/A"
              }}</span>
              <!-- <span>{{
                organizationName(transaction.shipping.shippingservice)
              }}</span> -->
            </li>
            <li class="flex items-center justify-between">
              <span>Gross Weight</span>

              <span>{{ totalWeight || 0 }} (KG)</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Total Shipment Cost</span>
              <span class="font-bold">&#8358; {{ transaction.totalValue - 0 }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="flex w-full lg:w-4/12 md:w-6/12 py-3 justify-between border-4 border-white">
        <div v-for="detail in [1]" :key="detail" class="detail-container py-3 px-3">
          <b class="py-2 inline-block">Sender Info</b>
          <ul class="detail-list">
            <li class="flex items-center justify-between">
              <span>Name</span>
              <span>{{
                transaction.shipping.shipperlocation.contactName
                  ? transaction.shipping.shipperlocation.contactName
                  : "N/A"
              }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>MuleEx ID</span>
              <!-- <span>{{transaction.shipping.shipperlocation? transaction.shipping.shipperlocation :  "N/A"}}</span> -->
              <span>N/A</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Address</span>
              <span>{{
                transaction.shipping.shipperlocation.address
                  ? transaction.shipping.shipperlocation.address.name
                  : "N/A"
              }}
              </span>
            </li>
            <li class="flex items-center justify-between">
              <span>Email</span>
              <span>{{
                transaction.shipping.shipperlocation && transaction.shipping.shipperlocation.email
                  ? transaction.shipping.shipperlocation.email
                  : "N/A"
              }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Phone Number</span>
              <span>{{
                transaction.shipping.shipperlocation.mobile
                  ? transaction.shipping.shipperlocation.mobile
                  : "N/A"
              }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Shipment Date</span>
              <span v-if="!hasTrip(transaction)" class="font-bold">
                {{
                  transaction.shipping.pickUpDays
                    ? `&#8358; ${transaction.shipping.pickUpDays}`
                    : "N/A"
                }}
              </span>
              <span v-else>
                {{
                  transaction.shipping
                    ? returnStringDate(
                      transaction.shipping.trip.pickUpVerifiedAt
                    )
                    : "N/A"
                }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex w-full lg:w-4/12 md:w-6/12 py-3 justify-between border-4 border-white">
        <div v-for="(detail,index) in [1]" :key="index+'reciever'" class="detail-container py-3 px-3">
          <b class="py-2 inline-block">Receiver Info</b>
          <ul class="detail-list">
            <li class="flex items-center justify-between">
              <span>Name:</span>
              <span>{{ transaction.shipping  ? receieverContactName :
                "N/A" }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>MuleEX ID:</span>
              <!-- <span>{{transaction.shipping.consigneelocation? transaction.shipping.consigneelocation :  "N/A"}}</span> -->
              <span>N/A</span>
            </li>
             <li class="flex items-center justify-between">
              <span>Address:</span>
              <span>{{
                transaction.shipping
                  ? formatAddress(
                    receieverAddress ||
                    ","
                  )
                  : "N/A"
              }}
              </span>
            </li>
            <li class="flex items-center justify-between">
              <span>Email:</span>
              <span>{{
                transaction.shipping ? receieverEmail
                  : "N/A"
              }}</span>
            </li>
            <li class="flex items-center justify-between">
              <span>Phone Number:</span>
              <span>{{
                transaction.shipping ? receieverMobile
                  : "N/A"
              }}</span>
            </li> 
            <li class="flex items-center justify-between">
              <span>Est. Delivery Date:</span>
              <span v-if="!hasTrip(transaction)" class="font-bold">
                {{
                  transaction.shipping.dropOff
                    ? `&#8358; ${transaction.shipping.dropOff}`
                    : "N/A"
                }}</span>
              <span v-else>
                {{
                  transaction.shipping
                    ? returnStringDate(
                      transaction.shipping.trip.fulfilmentVerifiedAt
                    )
                    : "N/A"
                }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="text-left py-5 overflow-x-auto">
      <table width="100%" class="slide-table">
        <thead>
          <tr>
            <th>Shipping Reference</th>
            <th>Item Description</th>
            <th>Packaging</th>
            <th>Quantity</th>
            <th>Total Weight (KG)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in transaction.shipping.packagees" :key="item.description">
            <td>{{ transaction.shipping && transaction.shipping.shippingReference}}</td>
            <td>{{ item.description ? item.description : "N/A" }}</td>
            <td>{{ item.packageType ? item.packageType : "N/A" }}</td>
            <td>{{ item.quantity ? item.quantity : "N/A" }}</td>
            <td>{{ item.estimatedWeight ? item.estimatedWeight : "N/A" }} (KG)</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-gray-100 py-3 flex px-3 items-center flex-wrap">
      <div class="w-full md:w-6/12">
        <label class="w-full block">Coupon Code</label>
        <input placeholder="--Enter--" class="w-6/12 p-2" />
      </div>

      <div class="md:w-3/12 w-6/12 text-center">
        <ul class="text-left md:text-right ship-content">
          <li class="whitespace-nowrap">Gross Weight:</li>
          <li class="whitespace-nowrap">Net Shipment Cost:</li>
          <li class="whitespace-nowrap">Discount:</li>
          <li><b class="w-full block pt-2">Total Shipping Cost:</b></li>
        </ul>
      </div>

      <div class="md:w-3/12 w-6/12 text-right">
        <ul class="text-right ship-content">
          <li>{{ totalWeight }} (KG)</li>
          <li>&#8358; {{ transaction.totalValue }}</li>
          <li>&#8358; 0</li>
        </ul>
        <b class="w-full text-right block pt-2">
          &#8358; {{ transaction.totalValue - 0 }}</b>
      </div>
    </div>

    <div class="py-5 text-center">
      <h6 class="font-bold pb-2">Customer Care</h6>
      <p>
        For questions and enquiries regarding your shipment, kindly contact
        MuleEx global support team on support@muleex.com.
      </p>
    </div>

    <div class="py-4 text-center bg-gray-100 px-3">
      <h6 class="pb-2">Powered By MuleEx Technologies Ltd.</h6>
      <p>
        This is a system generated document from MuleEx. MuleEx is a
        multicarrier logistics platform for third-party logistics providers and
        customers. <b>Visit www.muleex.com</b> to create your free account.
      </p>
      <p class="py-4 mt-8">
        Save Earth, Go Paperless. Join so many other amazing providers and
        customers on MuleEx.
      </p>
      <p>
        Document Type: Shipment Receipt | DateTime Created: {{ stringDate }} |
        Shipping ID #:
        {{
          transaction.shipping ? transaction.shipping.shippingReference : "N/A"
        }}
        | Document Version: 1
      </p>
    </div>
    <DeleteQuoteModal :show-modal="showDeleteModal" :quoteId="quoteId"
      @close-modal="showDeleteModal = false" />
  </div>

</template>

<script>
import DeleteQuoteModal from "../../../../components/Ondemand/Bookings/modals/DeleteQuoteModal.vue"
// import DeleteQuoteModal from "~components/"
import html2pdf from "html2pdf.js";
import moment from "moment";

export default {
  components: {
    DeleteQuoteModal,
  },
  data() {
    return {
      quoteId : null,
      showDeleteModal: false,
      transactionId: this.$route.params.id,
      transaction: {},
    };
  },
  mounted() {
    this.getReciept();
  },
  computed: {
        receieverEmail() {
      return (this.transaction.shipping?.shipmentReceiever || []).map((item) => item?.location?.email).join(",")
    },
       receieverContactName() {
      return (this.transaction.shipping?.shipmentReceiever || []).map((item) => item?.location?.contactName).join(",")
    },
    receieverMobile() {
      return (this.transaction.shipping?.shipmentReceiever || []).map((item) => item?.location?.mobile).join(",")
    },
      receieverAddress() {
      return (this.transaction.shipping?.shipmentReceiever || []).map((item) => item?.location?.address?.address).join(",")
    },
    stringDate() {
      let dateString = this.transaction?.createdAt || "";
      return (
        moment.utc(dateString).local().format("DD MMMM YYYY, HH:mm") || "--"
      );
    },
    transactionHeader() {
      let header = "";
      switch (this.type) {
        case "quote":
          header = " Estimates";
          break;
        case "recievable":
          header = " Receivables";
          break;
        default:
          header = "  Collections (Shipment Receipt)";
          break;
      }
      return header;
    },
    type() {
      return localStorage.getItem("billing_reciept");
    },
    discription() {
      if (!this.transaction?.shipping?.packagees.length) return "";
      return this.transaction?.shipping?.packagees
        .map((item) => (item?.description ? item?.description + ", " : ""))
        .reduce((prev, next) => prev + next);
    },
    totalWeight() {
      if (!this.transaction?.shipping?.packagees.length) return 0;
      return this.transaction.shipping.packagees
        .map((item) => item.estimatedWeight)
        .reduce((prev, next) => prev + next);
    },
  },
  methods: {
    navigateToReg() {
      if (this.type === "quote") {
       localStorage.setItem("billing_reciept", "quote");
      this.$router.push( {name : "QuoteAndDraft"})
      }
      if (this.type === "recievable") {
       localStorage.setItem("billing_reciept", "recievable");
      this.$router.push( {name : "HistoricalBookings"})
      }
      if (this.type === "active") {
        localStorage.setItem("billing_receipt", "active") 
        this.$router.push( {name : "ActiveBookings"})
      } 
      if (this.type === "transactions") {
        localStorage.setItem("billing_receipt", "transactions") 
        this.$router.push( {name : "PaymentsTransaction"})
      }    
      
    },
    deleteQuote(val) {
      this.showDeleteModal = true
      this.quoteId = val?.shipping?.id
    }, 
    setBookingFlowState(val) {
      let splitval = {
        consignee: val?.shipping?.consigneelocation,
        prevShipper: val?.shpping?.shipperlocation,
        shippingInformation: val,
        packages: val?.shipping?.packagees,
      };
      this.$store.dispatch("saveLatestInitialBookingData", splitval);
      this.$store.dispatch("saveLatestNewInitialShipping", val);
      this.$store.dispatch("saveLatestNewShippingForSelf", false);
      this.$router.push({ name: "BookingFlow" });
      this.$store.dispatch("saveLatestNewBookinTabNum", 1);
    },

  

    hasTrip(val) {
      return val?.shipping?.tripId;
    },
    // organizationName(shipping) {
    //   return shipping ? "hs" : "hs";
    // },
    returnStringDate(dateString) {
      return moment(dateString).format("DD/MM/YYYY, HH:mm") || "--";
    },
    generateQuote() {
      try {
        var element = document.getElementById("quoteGen");
        html2pdf(element);
      } catch (e) {
        // ...any code here
      }
    },
    async getReciept() {
      try {
        let response = await this.$_getReciept(this.transactionId);
        this.transaction = response.data.data.transaction;
        console.log("---transaction", this.transaction);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-wrap{
  gap : 4%;
}
.invoice-wrap>button{
  color : #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  background: #10233E;
  border-radius: 5px;
}
.title-container {
  @apply flex bg-primary-yellow py-4 px-3 rounded-md;
}

.ship-content {
  li {
    @apply pt-2;
  }
}

.detail-container {
  @apply bg-gray-100 rounded-md;
  width: 100%;
}

.detail-list {
  li {
    @apply py-2 opacity-50 flex items-start;

    span:nth-of-type(1) {
      @apply inline-block mr-2;
    }

    span:nth-of-type(2) {
      @apply inline-block text-right;
    }
  }
}

td {
  @apply pl-0;
}

th {
  @apply pb-2;
}

tr {
  @apply border-gray-200;
  border-bottom-width: 2px;
}

.slide-table {
  width: 100%;
  min-width: 700px;
}
</style>
